import type { Feature } from '../types/feature.types';

export type SortBy = 'votes' | 'newest';

export function sortFeatures(features: Feature[], sortBy: SortBy): Feature[] {
	return [...features].sort((a, b) => {
		if (sortBy === 'votes') {
			return (
				b.votes - a.votes || Number(b.createdAt) - Number(a.createdAt)
			);
		}
		return Number(b.createdAt) - Number(a.createdAt);
	});
}
